<template>
  <div>
    <div id="pdf">
      <vue-pdf-embed :source="sourceUrl" />
    </div>
  </div>
</template>

<script>
import config from "@/config";
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";

export default {
  name: "ModalPreviewPDF",

  props: {
    currentDocumento: { type: Object },
  },

  data() {
    return {
      sourceUrl: this.currentDocumento.documento + config.CD_STG_ACCESS_KEY,
    };
  },

  components: {
    VuePdfEmbed,
  },
};
</script>

<style>
#pdf {
  width: 80%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.vue-pdf-embed > div {
  margin-bottom: 8px;
  box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
}
</style>
